// Marketing Content Variant A - Feature-Focused (Original)
export const marketingContentA = {
  home: {
    hero: {
      title: "Automate Rent Collection.\nStay Compliant.\nDelight Your Tenants.",
      subtitle: "The all-in-one platform that makes rent collection effortless, keeps you compliant with Quebec regulations, and helps you build better relationships with your tenants.",
      ctaButton: "Book a Demo",
      ctaSubtext: "No credit card required • Free 30-day trial"
    },
    features: {
      title: "Everything You Need in One Platform",
      subtitle: "Built specifically for Quebec landlords who want to work smarter, not harder.",
      feature1Title: "Automated Rent Collection",
      feature1Desc: "Set it and forget it. Collect rent via pre-authorized debits, e-transfers, or credit cards.",
      feature2Title: "Payment Tracking",
      feature2Desc: "Real-time dashboard shows who's paid, who's late, and what's coming next.",
      feature3Title: "Instant Reconciliation",
      feature3Desc: "Automatic matching of payments to units. No more spreadsheet headaches.",
      feature4Title: "Compliance Built-In",
      feature4Desc: "Stay compliant with Quebec's Régie du logement requirements automatically.",
      feature5Title: "Bank-Grade Security",
      feature5Desc: "Your data is encrypted and secure. SOC 2 Type II certified.",
      feature6Title: "Analytics & Insights",
      feature6Desc: "Understand your cash flow, predict trends, and make data-driven decisions."
    },
    testimonials: {
      title: "What Our Customers Say",
      testimonial1Quote: "DossiLoc saved me 10+ hours per month on rent collection. The automation is incredible.",
      testimonial1Author: "Sarah L., Landlord (12 units)",
      testimonial2Quote: "Finally, a platform built for Quebec landlords. The compliance features alone are worth it.",
      testimonial2Author: "Mike D., Property Manager (45 units)"
    },
    cta: {
      title: "Ready to Transform Your Rent Collection?",
      subtitle: "Join hundreds of Quebec landlords who've automated their rent collection and reclaimed their time.",
      button: "Get Started Free"
    },
    footer: {
      termsOfService: "Terms of Service",
      privacyPolicy: "Privacy Policy",
      security: "Security",
      contactSupport: "Contact Support",
      copyright: "© 2025 DossiLoc Inc. All rights reserved."
    }
  },
  landing: {
    title: "See DossiLoc in Action",
    subtitle: "Book a personalized demo and discover how DossiLoc can transform your rent collection process.",
    benefitsTitle: "What You'll Learn:",
    benefit1: "How to automate 100% of your rent collection",
    benefit2: "Ways to stay compliant with Quebec regulations",
    benefit3: "Tips to improve tenant satisfaction and reduce late payments",
    benefit4: "How other landlords are saving 10+ hours per month",
    contactTitle: "Questions? Contact Us:",
    contactEmail: "demo@dossiloc.ca",
    contactPhone: "+1 (514) 123-4567",
    contactLocation: "410 rue Saint-Nicolas, suite 236, Montréal (Québec) H2Y 2P5",
    formTitle: "Request Your Free Demo",
    formNameLabel: "Full Name",
    formNamePlaceholder: "John Smith",
    formEmailLabel: "Email Address",
    formEmailPlaceholder: "john@example.com",
    formPhoneLabel: "Phone Number (Optional)",
    formPhonePlaceholder: "+1 (555) 123-4567",
    formRoleLabel: "Your Role",
    formRolePlaceholder: "e.g., Landlord, Property Manager",
    formUnitsLabel: "Number of Units (Optional)",
    formUnitsPlaceholder: "e.g., 10, 25, 50",
    formMessageLabel: "Additional Information",
    formMessagePlaceholder: "Tell us about your needs or questions...",
    formSubmitButton: "Book My Demo",
    formSubmitting: "Submitting...",
    formPrivacyNotice: "We respect your privacy. Your information will never be shared.",
    toastSuccessTitle: "Demo Request Received!",
    toastSuccessDesc: "We'll contact you within 24 hours to schedule your personalized demo.",
    toastErrorTitle: "Submission Failed",
    toastErrorDesc: "Please try again or contact us directly at demo@dossiloc.ca",
    successTitle: "Thank You!",
    successMessage: "We've received your demo request and will be in touch within 24 hours to schedule a time that works for you.",
    successButton: "Return to Home"
  }
};
